export default {
  LOTTERY_CONTACT_INFO: 'LOTTERY_CONTACT_INFO',
  CONTACT_THE_LOTTERY: 'CONTACT_THE_LOTTERY',
};



// WEBPACK FOOTER //
// ./src/modules/contact/components/contact-us/tabs.js